import { cloneDeep, get, omit, set } from 'lodash-es';

import { type CanvasElementOverrides, type PartialPropsOf } from '@blaze-runtime/engine-domain';

import {
  type CanvasElementDefinition,
  type CanvasElementDefinitionInternal,
} from '../../canvas-elements/element-definition';
import { forEachOverride } from '../../canvas-elements/element-model/props-overrides';

export const cleanStylePaths = (
  originalProps: PartialPropsOf,
  definition: CanvasElementDefinition | CanvasElementDefinitionInternal | undefined,
): any => {
  if (!originalProps || !definition) {
    return originalProps;
  }
  const { styleExcludePaths = [], styleIncludePaths = [] } = definition;
  let cleanedObject = cloneDeep(originalProps);
  styleIncludePaths.forEach((path) => {
    cleanedObject = omit(cleanedObject, path);
  });
  styleExcludePaths.forEach((path) => {
    set(cleanedObject, path, get(originalProps, path));
  });
  return cleanedObject;
};

export const cleanStylePathsFromPropsOverrides = (
  overrides: CanvasElementOverrides | undefined,
  definition: CanvasElementDefinition | CanvasElementDefinitionInternal | undefined,
): CanvasElementOverrides | undefined => {
  if (!overrides) {
    return overrides;
  }

  forEachOverride(overrides, (override, target) => {
    if (!override.props) {
      return;
    }

    overrides[target] = {
      ...overrides[target],
      props: cleanStylePaths(override.props, definition),
    };
  });

  return overrides;
};
